export const PreviousLocationDepth: number = 5;
